//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('consignmentPlansDeliveryLabour', {
//        templateUrl: 'views/components/views/consignmentPlansDeliveryLabour/consignmentPlansDeliveryLabour.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'consignmentPlansDeliveryLabourService', 'rememberService', function (stateService, consignmentPlansDeliveryLabourService, rememberService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                searchTextButtons: [
//                    { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.setting.searchtext = '' }
//                ],
//                setting: {
//                    searchtext: ''
//                },
//                itemsListLabours: []
//            };

//            // #region VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadLabours() {
//                vm.model.itemsListLabours = await consignmentPlansDeliveryLabourService.listLabours();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region SAVE ITEM & GO BACK FUNCTION

//            vm.saveLabour = function (item) {
//                Promise.all([
//                    rememberService.remember('consignmentplansdelivery.labour_no', item.item_id),
//                    rememberService.remember('consignmentplansdelivery.labour_name', item.item_name)
//                ]).then(() => {
//                    stateService.back();
//                    Promise.resolve();
//                });
//            }

//            // #endregion SAVE ITEM & GO BACK FUNCTION

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadLabours();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
